






















































import handlesShortlistMeApplications from "~/mixins/handlesShortlistMeApplications";
import AppBadge from "~/components/global/AppBadge.vue";

export default {
	name: 'MockJobDetailsDialog',
	components: {AppBadge},

	mixins: [
		handlesShortlistMeApplications,
	],

	props: {
		job: {
			type: Object,
			required: true,
		},
	},
}
